import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/sephirothMailAssoc';
import { selectors, DEFAULT_STATE } from '../reducers/sephirothMailAssoc';
import api from '../apis/sephirothMailAssoc';

const sagas = helper.createSagas(
    'sephirothMailAssoc',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        idKey: 'id'
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
